module.exports = __webpack_public_path__ + "static/img/1.d8574cdf.svg";